
<div class="view-content">News content 1</div>
<div class="view-content">News content 2</div>
<div class="view-content">News content 3</div>
<div class="view-content">News content 4</div>
<div class="view-content">News content 5</div>